export default __webpack_public_path__ + "static/media/IMG_0575.63ca1cad.jpg";